import qs from "qs"; // Install qs library: `npm install qs`
import api from "../sharedInterceptors";

api.defaults.baseURL = process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1;
class HistoricAPI {
  async getActiveFiresApi(startDate, endDate, startTime, endTime) {
    const params = {};

    if (startDate) params.date_from = startDate;
    if (endDate) params.date_to = endDate;
    if (startTime) params.time_from = startTime;
    if (endTime) params.time_to = endTime;

    return await api.get(
      `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/active-fires`,
      {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
      },
    );
  }
  async getAllHistoricFiresApi({
    country,
    departments,
    dateFrom,
    dateTo,
  } = {}) {
    const urlParams = new URLSearchParams();

    if (country) urlParams.append("country", country);
    if (Array.isArray(departments) && departments.length > 0) {
      departments.forEach((dep) => urlParams.append("department", dep));
    }
    if (dateFrom) urlParams.append("date_from", dateFrom);
    if (dateTo) urlParams.append("date_to", dateTo);
    const query = urlParams.toString();
    return await api.get(
      `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/historicfire/get_all/${
        query ? `?${query}` : ""
      }`,
    );
  }
  async getHistoricFiresByDateApi(startDate, endDate, country, departments) {
    const params = {};

    if (startDate) params.date_from = startDate;
    if (endDate) params.date_to = endDate;
    if (country) params.country = country;
    if (Array.isArray(departments) && departments.length > 0) {
      params.department = departments;
    }

    return await api.get(
      `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/historicfire/get_by_filter/`,
      {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
      },
    );
  }
  async getHistoricFiresByIdsApi(ids) {
    return await api.get(
      `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/historicfire/get_polygons/`,
      {
        params: {
          ids,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" }); //The qs library allows flexible query parameter serialization.
          //{ arrayFormat: 'repeat' } ensures that the array is serialized as ?ids=183&ids=184 instead of ?ids[]=183&ids[]=184.
        },
      },
    );
  }
}

export default HistoricAPI;
